export const EXPERIENCE_COUNT = [
  {
    title: "Less than 1 year",
    count: 0,
  },
  {
    title: "1-2 years",
    count: 0,
  },
  {
    title: "3-5 years",
    count: 0,
  },
  {
    title: "6-10 years",
    count: 0,
  },
  {
    title: "More than 10 years",
    count: 0,
  },
  {
    title: "Others",
    count: 0,
  },
];

export const GIG_COUNT = [
  {
    title: "Contract",
    count: 155,
  },
  {
    title: "Permanent",
    count: 184,
  },
];
